/*
CODE WRITTEN BY
© Selcuk Gürsoy
https://www.linkedin.com/in/selcuk-g-338464237/
*/
function getUrlParameter(name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}


/* Footer */
if(document.querySelectorAll('.footer-block.footer-block--menu .footer-block__heading').length > 0){
  let firstElement = document.querySelectorAll('.footer-block.footer-block--menu .footer-block__heading')[0];
  firstElement.nextElementSibling.style.height = firstElement.nextElementSibling.scrollHeight + 'px';
  firstElement.parentElement.classList.add('active');
  document.querySelectorAll('.footer-block.footer-block--menu .footer-block__heading').forEach(function(footerTextItem){
    footerTextItem.addEventListener('click', function(){
        if (this.parentElement.classList.contains('active')) {
          this.nextElementSibling.style.height = '0';
          this.parentElement.classList.remove('active');
        } else {
          this.nextElementSibling.style.height = this.nextElementSibling.scrollHeight + 'px';
          this.parentElement.classList.add('active');
        }
    });
  });
}

/* Vorverkauf 2025 */
if(document.querySelectorAll('.sg-campaign-lp-vipInfo-button, .sg-campaign-lp-header-content-button').length !== 0){
  document.querySelectorAll('.sg-campaign-lp-vipInfo-button, .sg-campaign-lp-header-content-button').forEach(function(button){
    button.addEventListener('click', function(e){
      e.preventDefault();
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'VUeYDv']);
      //if(document.getElementById('sg-campaign-lp-popup-container') !== null){
      //  document.getElementById('sg-campaign-lp-popup-container').classList.add('active');
      //}
    });
  });
}
//if(document.getElementById('sg-campaign-lp-popup-close') !== null){
//  document.getElementById('sg-campaign-lp-popup-close').addEventListener('click', function(){
//    document.getElementById('sg-campaign-lp-popup-container').classList.remove('active');
//  });
//}
document.addEventListener("DOMContentLoaded", function() {
    const shareBtn = document.querySelector(".vorverkauf_dankesseite_slider .button.button--primary");
    if(shareBtn !== null){
      shareBtn.addEventListener("click", function () {
          const shareData = {
              title: document.title,
              text: "Schau dir das mal an!",
              url: "https://www.allgaeuer-wanderimkerei.de/pages/vorverkauf-anmeldung"
          };
          // ✅ Web Share API (für Mobilgeräte & moderne Browser)
          if (navigator.share) {
              navigator.share(shareData).catch(console.error);
          } else {
              // ✅ Fallback: WhatsApp-Link öffnen
              const whatsappUrl =
                  "https://wa.me/?text=" + encodeURIComponent(`${shareData.text} ${shareData.url}`);
              window.open(whatsappUrl, "_blank");
          }
      });
    }
});



/* Redirect collection page */
if (window.location.pathname == "/collections") {
    window.location.href = "/collections/alle-honige"; 
}
/* Redirect Herbstaktion-LP auf Homepage */
if (window.location.pathname == "/pages/herbstaktion-2024" || window.location.pathname == "/pages/herbstaktion-2024-danke") {
    window.location.href = "/";
}

/* Remove Filter Option */
document.querySelectorAll('.list-menu__item.facets__item > .facet-checkbox').forEach(function(filterItem){
  if(filterItem.firstChild.nextElementSibling.value === '-'){
    filterItem.style.display = "none"; 
  }
});
/* Remove Filter Option Mobile */
document.querySelectorAll('.list-menu__item.mobile-facets__item .mobile-facets__checkbox').forEach(function(filterItem){
  console.log(filterItem.value);
  if(filterItem.value === '-'){
    filterItem.parentElement.style.display = "none"; 
  }
});

const timers = document.querySelectorAll('.sg-timer-container');
if (timers.length > 0) {
  timers.forEach(function(timer){
    const {
      year,
      month,
      day,
      hour,
      minute,
      second
    } = timer.dataset;

    //console.log('Year:', year);
    //console.log('Month:', month);
    //console.log('Day:', day);
    //console.log('Hour:', hour);
    //console.log('Minute:', minute);
    //console.log('Second:', second);
    
    // Set the date we're counting down to
    // new Date(year,month,day,hours,minutes,seconds,ms)
    var countDownDate = new Date(year, (month-1), day, hour, minute, second, 0);
    countDownDate = countDownDate.getTime()  + (60 * 1000 * 60);
    
    // Update the count down every 1 second
    var timerInterval = setInterval(function() {
      // Get today's date and time
      let now = new Date();
      now = now.getTime() + (60 * 1000 * 60);
    
      // Find the distance between now and the count down date
      let distance = countDownDate - now;
    
      // Time calculations for days, hours, minutes
      let days = Math.floor(distance / (1000 * 60 * 60 * 24));
      let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((distance % (1000 * 60)) / (1000));
    
      // Display the result in the element
      document.querySelectorAll('.sg-timer-value-days').forEach(function(daysInput){
        daysInput.innerHTML = days;
      });
      document.querySelectorAll('.sg-timer-value-hours').forEach(function(hoursInput){
        hoursInput.innerHTML = hours;
      });
      document.querySelectorAll('.sg-timer-value-minutes').forEach(function(minuntesInput){
        minuntesInput.innerHTML = minutes;
      });
      document.querySelectorAll('.sg-timer-value-seconds').forEach(function(secondsInput){
        secondsInput.innerHTML = seconds;
      });

      // If the count down is finished remove timer
      //if (distance < 0) {
      //  clearInterval(timerInterval);
      //  document.getElementById("sg-timer-container").style.display = "none";
      //}
      
    }, 1000);
  });
}




/* Honigtopf Keine Gravur Checkbox */
const honigtopfCheckbox = document.getElementById('sg-honigtopf-checkbox');
document.addEventListener('DOMContentLoaded', function () {
  if (honigtopfCheckbox) {
    honigtopfCheckbox.addEventListener('change', function () {
      const textInput = document.querySelector('.cl-po--input:not(.choices__input)');
      const selectInput = document.querySelector('.cl-po--input.choices__input');
      const selectWrapper = document.querySelector('.cl-po--font-selector');
      const radioInputs = document.querySelectorAll('.cl-po--swatch-item > .cl-po--input');
  
      if (honigtopfCheckbox.checked) {
        if (textInput) {
          textInput.classList.add('disabled');
          textInput.disabled = true;
        }
        if (selectInput) {
          selectInput.classList.add('disabled');
          selectInput.disabled = true;
          selectWrapper.classList.add('disabled');
        }
        if (radioInputs) {
          radioInputs.forEach(function(radioInput){
            radioInput.classList.add('disabled');
            radioInput.disabled = true;
          });
        }
      } else {
        if (textInput) {
          textInput.classList.remove('disabled');
          textInput.disabled = false;
        }
        if (selectInput) {
          selectInput.classList.remove('disabled');
          selectInput.disabled = false;
          selectWrapper.classList.remove('disabled');
        }
        if (radioInputs) {
          radioInputs.forEach(function(radioInput){
            radioInput.classList.remove('disabled');
            radioInput.disabled = false;
          });
        }
      }
    });
  }
});


/* Product Detail Page popup */
const buttonElements = document.querySelectorAll('body.honigtopf .product-form__submit.button, .grid__item.honigtopf .quick-add__submit');
if (buttonElements.length !== 0) {
  buttonElements.forEach(function(button){
    button.addEventListener('click', function (event) {
      const input1 = document.querySelector('.cl-po--input');
      const input2 = document.querySelector('.cl-po--input.choices__input');
      
      // Werte auslesen
      const value1 = input1 ? input1.value.trim() : '';
      const value2 = input2 ? input2.value.trim() : '';
      console.log(honigtopfCheckbox.checked);
      if ((value1 === '' || value2 === '') && !honigtopfCheckbox.checked) {
        event.preventDefault();
        const popup = document.getElementById('sg-product-detail-popup-container');
        popup.classList.add('active');
        // Automatisch ausblenden nach 8 Sekunden
        setTimeout(() => {
        popup.classList.remove('active');
        }, 8000);
      } else {
        document.getElementById('sg-product-detail-popup-container').classList.remove('active');
      }
    }, false);
  });
  const closeBtn = document.querySelector('.sg-product-detail-popup-container .close-popup');
  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      document.getElementById('sg-product-detail-popup-container').classList.remove('active');
    });
  }
}


/* Product Detail Page accordion */
document.querySelectorAll('.sg-product-detail-accordion-title').forEach(function(accordionTitle){
  const panel = accordionTitle.nextElementSibling;
  const box = accordionTitle.parentElement;
  if (!panel || !panel.classList.contains('sg-product-detail-accordion-value')) return;
  let animationFrame;
  let settleTimer;

  function updateAccessibility(expanded) {
    accordionTitle.setAttribute('aria-expanded', String(expanded));
    panel.setAttribute('aria-hidden', String(!expanded));
    panel.inert = !expanded;
  }

  function settleOpenPanel() {
    if (box.classList.contains('active')) panel.style.maxHeight = 'none';
  }

  function toggleAccordion() {
    cancelAnimationFrame(animationFrame);
    clearTimeout(settleTimer);
    const expanded = !box.classList.contains('active');
    const height = panel.scrollHeight;
    panel.style.maxHeight = height + 'px';
    box.classList.toggle('active', expanded);
    updateAccessibility(expanded);

    if (expanded) {
      settleTimer = setTimeout(settleOpenPanel, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 450);
    } else {
      animationFrame = requestAnimationFrame(function () {
        animationFrame = requestAnimationFrame(function () {
          if (!box.classList.contains('active')) panel.style.maxHeight = '0px';
        });
      });
    }
  }

  accordionTitle.setAttribute('role', 'button');
  accordionTitle.setAttribute('tabindex', '0');
  updateAccessibility(box.classList.contains('active'));
  settleOpenPanel();
  accordionTitle.addEventListener('click', toggleAccordion);
  accordionTitle.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    toggleAccordion();
  });
  panel.addEventListener('transitionend', function (event) {
    if (event.target === panel && event.propertyName === 'max-height') {
      clearTimeout(settleTimer);
      settleOpenPanel();
    }
  });
});


(function () {
  const observedProducts = new WeakSet();
  const radioSelector = '.appstle_subscription_radio_wrapper';

  function observeProduct(productInfo) {
    if (observedProducts.has(productInfo)) return;
    observedProducts.add(productInfo);
    let pendingFrame;

    function ensureBenefits() {
      pendingFrame = null;
      const radioWrapper = productInfo.querySelector(radioSelector);
      if (!radioWrapper || radioWrapper.parentElement.querySelector('.sg-appstle-benefits')) return;
      radioWrapper.insertAdjacentHTML('afterend', `
        <div class="sg-appstle-benefits">
          <ul>
            <li><strong>Willkommensgeschenke</strong></li>
            <li><strong>Kostenlose Lieferung</strong></li>
            <li><strong>Jederzeit pausieren & kündigen</strong></li>
          </ul>
        </div>
      `);
    }

    const observer = new MutationObserver(function (records) {
      const widgetChanged = records.some(function (record) {
        return Array.from(record.addedNodes).some(function (node) {
          return node.nodeType === 1 && (node.matches(radioSelector) || node.querySelector(radioSelector));
        }) || Array.from(record.removedNodes).some(function (node) {
          return node.nodeType === 1 && (node.matches('.sg-appstle-benefits') || node.querySelector('.sg-appstle-benefits'));
        });
      });
      if (widgetChanged && !pendingFrame) pendingFrame = requestAnimationFrame(ensureBenefits);
    });
    observer.observe(productInfo, { childList: true, subtree: true });
    ensureBenefits();
  }

  function initializeBenefits() {
    document.querySelectorAll('product-info').forEach(observeProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeBenefits, { once: true });
  } else {
    initializeBenefits();
  }
  document.addEventListener('shopify:section:load', initializeBenefits);
  document.addEventListener('product-info:loaded', initializeBenefits);
})();
